// Quiz.js
// Expose a namespace


globalThis.IWWQuiz = {
    init: function({ containerSelector = '.iww-quiz', jsonData = null } = {}) {
        const containers = document.querySelectorAll(containerSelector);

        containers.forEach(container => {
            const card = container.querySelector('#quiz-card');
            let quizData = jsonData;

            if (!quizData) {
                try {
                    quizData = JSON.parse(container.dataset.quizJson);
                } catch (err) {
                    card.innerHTML = `<div class="text-red-600 font-bold">Quiz konnte nicht geladen werden: ${err}</div>`;
                    return;
                }
            }

            startQuiz(quizData, card);
        });

        function startQuiz(quizData, quizCard) {
            let selectedQuestions = [];
            let currentIndex = 0;
            let userAnswers = [];

            function shuffleArray(arr) {
                return arr.map(v => ({ sort: Math.random(), value: v }))
                    .sort((a, b) => a.sort - b.sort)
                    .map(v => v.value);
            }

            function initQuiz() {
                let questions = quizData.fragen;

                if (quizData.fragenRandomisieren) questions = shuffleArray(questions);
                if (quizData.fragenLimitieren) {
                    const limit = parseInt(quizData.anzahlFragen, 10);
                    questions = questions.slice(0, limit);
                }

                selectedQuestions = questions;
                currentIndex = 0;
                userAnswers = [];
                showQuestion();
            }

            function showQuestion() {
                const q = selectedQuestions[currentIndex];

                quizCard.innerHTML = `
          <div class="bg-skin-lightest shadow-lg rounded-xl p-6 max-w-lg mx-auto">
            <h2 class="text-xl font-semibold mb-4">Frage ${currentIndex + 1} von ${selectedQuestions.length}</h2>
            <p class="mb-4">${q.frage}</p>
            <div class="answers space-y-2">
              ${q.antworten.map((a, i) => `
                <label class="flex items-center space-x-2">
                  <input type="checkbox" name="answer" value="${i}" class="form-checkbox h-5 w-5 text-blue-600"/>
                  <span>${a.antwort}</span>
                </label>`).join('')}
            </div>
            <div class="navigation flex justify-between mt-6">
              ${currentIndex>0 ? '<button id="prevBtn" class="px-6 py-4 border-buttongradientlight hover:border-buttongradientdark border-2 rounded-full inline-flex justify-center items-center text-center justify-center text-buttongradientlight hover:text-buttongradientdark text-base font-medium leading-none">Zurück</button>' : '<span></span>'}
              <button id="nextBtn" class="px-6 py-4 bg-gradient-to-b from-buttongradientlight to-buttongradientdark hover:from-buttongradientdark hover:to-buttongradientdark rounded-full inline-flex justify-center items-center text-center justify-center text-white text-base font-medium leading-none">
                ${currentIndex===selectedQuestions.length-1 ? 'Fertig' : 'Weiter'}
              </button>
            </div>
          </div>
        `;

                if (userAnswers[currentIndex]) {
                    userAnswers[currentIndex].forEach(i => {
                        quizCard.querySelector(`input[value="${i}"]`).checked = true;
                    });
                }

                quizCard.querySelector('#nextBtn').addEventListener('click', nextQuestion);
                if (currentIndex > 0) quizCard.querySelector('#prevBtn').addEventListener('click', prevQuestion);
            }

            function nextQuestion() {
                const selected = Array.from(quizCard.querySelectorAll("input[name=answer]:checked"))
                    .map(i => parseInt(i.value));
                userAnswers[currentIndex] = selected;

                if (currentIndex === selectedQuestions.length - 1) {
                    showResults();
                } else {
                    currentIndex++;
                    showQuestion();
                }
            }

            function prevQuestion() {
                const selected = Array.from(quizCard.querySelectorAll("input[name=answer]:checked"))
                    .map(i => parseInt(i.value));
                userAnswers[currentIndex] = selected;
                currentIndex--;
                showQuestion();
            }

            function showResults() {
                let correctCount = 0;
                let resultHTML = `<div class="space-y-4">`;

                selectedQuestions.forEach((q, qi) => {
                    const correctIndices = q.antworten.map((a,i)=>({...a,i})).filter(a=>a.antwortKorrekt).map(a=>a.i);
                    const selected = userAnswers[qi]||[];
                    const isCorrect = correctIndices.length===selected.length && correctIndices.every(i=>selected.includes(i));
                    if(isCorrect) correctCount++;

                    resultHTML += `
            <div class="p-4 rounded-lg ${isCorrect ? 'bg-green-100' : 'bg-red-100'}">
              <p class="font-semibold">Frage ${qi+1}: ${q.frage}</p>
              <p>Deine Antwort: ${selected.map(i=>q.antworten[i].antwort).join(", ")||"keine"}</p>
              <p>Richtige Antwort: ${correctIndices.map(i=>q.antworten[i].antwort).join(", ")}</p>
              <p class="${isCorrect ? 'text-green-700 font-bold' : 'text-red-700 font-bold'}">${isCorrect?"✅ Richtig":"❌ Falsch"}</p>
            </div>
          `;
                });

                resultHTML += `<div class="text-lg font-bold mt-4">Gesamtpunktzahl: ${correctCount} / ${selectedQuestions.length}</div>`;
                resultHTML += `<button id="restartBtn" class="mt-4 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Neustart</button></div>`;

                quizCard.innerHTML = resultHTML;
                quizCard.querySelector('#restartBtn').addEventListener('click', initQuiz);
            }

            initQuiz();
        }
    }
};
